import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { connect } from 'react-redux'

import { WRAP_UP_SLUG } from '../../constants/routes'

const mapStateToProps = (state) => {
    return {
        nav: state.nav
    }
}

const UniversalShareIcon = ({ nav }) => {
    const cleanUrl = () => {
        let copyUrl = nav?.activeUrl ? nav.activeUrl : window.location.href
        // If we're in TFTES we may have an extra part of the url we dont want
        if (nav.activeComponent === 'Character Story') {
            // drop any trailing slash so the last part is the slide segment, not ''
            const urlParts = copyUrl.replace(/\/+$/, '').split('/')
            const storyId = urlParts[urlParts.length - 1]
            // if storyId is a number or the wrap-up slug, remove it from the url
            if (!isNaN(storyId) || storyId === WRAP_UP_SLUG) {
                urlParts.pop()
            }
            copyUrl = urlParts.join('/')
        }
        return copyUrl
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(cleanUrl())
        alert('Copied to clipboard')
    }

    const clickHandler = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    url: cleanUrl()
                })
            } catch (err) {
                console.log('Share canclled')
            }
        } else {
            copyToClipboard()
        }
    }

    return (
        <button className="universal-share-icon icon-link" onClick={clickHandler}>
            <div className="visually-hidden">Share the current page</div>
            <FontAwesomeIcon icon="fa-solid fa-share-nodes" className="share-icon" aria-hidden="true" />
        </button>
    )
}

export default connect(mapStateToProps)(UniversalShareIcon)
